import apiClient from "./APIClient";

class GameActivationService {
 getCountries = async () => {
  try {
    const res = await apiClient.get('/country?lang=en');
    return res.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};

  getGameProductCategories = async () => {
    return await apiClient.get("/product-categories/game");
  }

  getGameProductTypes = async () => {
    return await apiClient.get("/product-types/game");
  }


 getGameProducts = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.countryId) {
      params.append('countryId', filters.countryId);
    }
    if (filters.productCategoryId) {
      params.append('productCategoryId', filters.productCategoryId);
    }
    if (filters.productTypeId) {
      params.append('productTypeId', filters.productTypeId);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/product/agent/games?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching social products:", error);
    throw error;
  }
};
  activateGameProduct = async (payload) => {
    return await apiClient.post("/manualGame/agent", payload);
  }

  getGameOrders = async (params) => {
    return await apiClient.get("/manualGame/orders", { params });
  }

  completeGameActivation = async (orderId) => {
    return await apiClient.patch(`/game-activation/agent-complete/${orderId}`);
  }

  rejectGameActivation = async (orderId, reason) => {
    return await apiClient.patch(`/game-activation/agent-reject/${orderId}`, { reason });
  }

  activateCustomerGameProduct = async (payload) => {
    return await apiClient.post("/game-activation/customer", payload);
  }

  completeCustomerGameActivation = async (orderId) => {
    return await apiClient.patch(`/game-activation/customer-complete/${orderId}`);
  }

  rejectCustomerGameActivation = async (orderId, reason) => {
    return await apiClient.patch(`/game-activation/customer-reject/${orderId}`, { reason });
  }

  getGameOrderById = async (orderId) => {
    return await apiClient.get(`/orders/${orderId}`);
  }
}

export default new GameActivationService();